import { useState, type FormEvent } from 'react'
import { useAuth } from '../auth'
import { ApiError } from '../api/client'
import { Notice } from '../components/ui'
import { IconEye, IconEyeOff, IconInventory } from '../components/icons'

export function Login() {
  const { login } = useAuth()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [reveal, setReveal] = useState(false)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await login(username, password)
    } catch (err) {
      setError(err)
    } finally {
      setBusy(false)
    }
  }

  return (
    <div className="center-screen">
      <form className="card login" onSubmit={onSubmit}>
        <div className="login-brand">
          <span className="brand-mark" aria-hidden="true">
            <IconInventory size={20} />
          </span>
          <div>
            <h1>域名库存与零售履历系统</h1>
            <p className="sub">内部系统 · 所有写入均记审计</p>
          </div>
        </div>
        <label className="field">
          <span>用户名</span>
          <input value={username} onChange={(e) => setUsername(e.target.value)} autoComplete="username" autoFocus />
        </label>
        <label className="field">
          <span>密码</span>
          <span className="input-affix">
            <input
              type={reveal ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
            <button
              type="button"
              onClick={() => setReveal((v) => !v)}
              aria-label={reveal ? '隐藏密码' : '显示密码'}
              aria-pressed={reveal}
              tabIndex={0}
            >
              {reveal ? <IconEyeOff size={15} /> : <IconEye size={15} />}
            </button>
          </span>
        </label>
        {error instanceof ApiError && error.code === 'RATE_LIMITED' ? (
          <Notice error={error} extra={<span className="sub">请 15 分钟后再试，或联系管理员核对账号。</span>} />
        ) : (
          <Notice error={error} />
        )}
        <button type="submit" className="primary" disabled={busy || !username || !password}>
          {busy ? (
            <>
              <span className="spin" aria-hidden="true" />
              登录中…
            </>
          ) : (
            '登录'
          )}
        </button>
        <p className="sub muted">忘记密码或账号被锁定，请联系管理员在服务器上处理，不要反复重试。</p>
      </form>
    </div>
  )
}
